import { datadogRum } from '@datadog/browser-rum';
import { LDFlagValue } from 'launchdarkly-js-sdk-common';

export function datadogRumAddFeatureFlagEvaluation(
  flagKey: string,
  flagValue: LDFlagValue,
) {
  datadogRum.addFeatureFlagEvaluation(flagKey, flagValue);
  const { feature_flags } = datadogRum.getGlobalContext();

  const currentFlags =
    typeof feature_flags === 'object' &&
    !Array.isArray(feature_flags) &&
    feature_flags !== null
      ? {
          ...feature_flags,
          [flagKey]: flagValue,
        }
      : {
          [flagKey]: flagValue,
        };

  datadogRum.setGlobalContextProperty('feature_flags', currentFlags);
}
